import { Controller } from "stimulus"
import { Ajax } from "ajax"

export default class extends Controller {

  static targets = [ "solution", "showAfterAnswer", "testQuestionPartial", "countHelpText", "submitButton" ]

  pluralize(count, one, other) {
    let countString = count;
    
    if (count >= 0 && count <= 12) {
      countString = [
        "keine",
        "eine",
        "zwei",
        "drei",
        "vier",
        "fünf",
        "sechs",
        "sieben",
        "acht",
        "neun",
        "zehn",
        "elf",
        "zwölf"
      ][count]
    }

    if (count == 1) {
      return `${countString} ${one}`;
    } else {
      return `${countString} ${other}`;
    }

  }

  toggle(e) {

    if (!e.currentTarget.classList.contains('answered')) {
      e.currentTarget.classList.toggle("checked")
      e.currentTarget.setAttribute("aria-checked", e.currentTarget.classList.contains('checked'));

      if (this.solutionTargets.some((element) => element.classList.contains("checked"))) {
        this.submitButtonTarget.disabled = false
      } else {
        this.submitButtonTarget.disabled = true
      }

    }

  }

  keydown(e) {
    
    if (e.which == 13 || e.which == 32) {
      this.toggle(e)
      e.preventDefault()
    }

  }

  submit(e) {
    if (e.currentTarget.classList.contains("submit")) {

      let correct = true
      let solutions = 0
      let correctSolutions = 0
      let falseNegatives = 0
      let falsePositives = 0

      this.solutionTargets.forEach((el) => {
        el.classList.add('answered')
        solutions += 1

        if (el.dataset.x == 'c' && el.classList.contains('checked')) {
          el.classList.add('true-positive')
          correctSolutions += 1
        } else if (el.dataset.x != 'c' && !el.classList.contains('checked')) {
          el.classList.add('true-negative')
          correctSolutions += 1
        } else if (el.dataset.x != 'c' && el.classList.contains('checked')) {
          el.classList.add('false-positive')
          falsePositives += 1
          correct = false
        } else {
          el.classList.add('false-negative')
          falseNegatives += 1
          correct = false
        }
      })

      if (falseNegatives > 0 && falsePositives > 0) {
        this.countHelpTextTarget.innerText = `Du hast ${this.pluralize(falsePositives, "falsche Antwort", "falsche Antworten")} ausgewählt und ${this.pluralize(falseNegatives, "richtige Antwort", "richtige Antworten")} nicht ausgewählt.`;
        this.countHelpTextTarget.classList.add("bad");
      } else if (falseNegatives > 0) {
        this.countHelpTextTarget.innerText = `Du hast ${this.pluralize(falseNegatives, "richtige Antwort", "richtige Antworten")} nicht ausgewählt.`;
        this.countHelpTextTarget.classList.add("bad");
      } else if (falsePositives > 0) {
        this.countHelpTextTarget.innerText = `Du hast ${this.pluralize(falsePositives, "falsche Antwort", "falsche Antworten")} ausgewählt.`;
        this.countHelpTextTarget.classList.add("bad");
      } else {
        this.countHelpTextTarget.innerText = `Du hast alles richtig ausgewählt.`;
        this.countHelpTextTarget.classList.add("good");
      }

      this.showAfterAnswerTargets.forEach((el) => {
        el.classList.add('visible')
      })

      let button = e.currentTarget

      Ajax.post(e.currentTarget.dataset.url, {
        round: e.currentTarget.dataset.round, 
        question: e.currentTarget.dataset.question, 
        video: e.currentTarget.dataset.video, 
        is_correct: correct, 
        solutions_count: solutions, 
        correct_solutions_count: correctSolutions
      }).then(() => {
        button.classList.remove("submit")
        button.classList.add("next")
        button.innerHTML = "Weiter"
        button.disabled = false
      }).catch(() => {
        console.log('test question submit reject')
      })

    } else if (e.currentTarget.classList.contains("next")) {
      if (e.currentTarget.classList.contains("quiz")) {
        window.scrollTo(0, 0)
        location.reload()
      } else {
        let button = e.currentTarget

        Ajax.get('/next-test-question/' + e.currentTarget.dataset.video + '/' + e.currentTarget.dataset.category).then((response) => {
          response.text().then((text) => {
            this.testQuestionPartialTargets.forEach((el) => {
              el.innerHTML = text;
            })
          }).catch(() => {
            console.log('test question next response text reject')
          })
        }).catch(() => {
          console.log('test question next reject')
        })
      }
    }

  }

}